module.exports = __webpack_public_path__ + "static/media/mobileicon.ecb41534.svg";